import EfIcon from '@elem/ui/ef-icon';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t: cp1 } = useLang('theProduct.NonstopPower.cp1');
    const { t: cp2 } = useLang('theProduct.NonstopPower.cp2');
    const { t: cp3 } = useLang('theProduct.NonstopPower.cp3');

    const getCpList = (cp: 'cp1' | 'cp2' | 'cp3') => {
        let t = cp1;
        let pc = 'https://websiteoss.ecoflow.com/upload/image/1732327804929/NonstopPower-cp-dialog.png';
        switch (cp) {
            case 'cp1':
                t = cp1;
                pc = 'https://websiteoss.ecoflow.com/upload/image/1732327804929/NonstopPower-cp-dialog.png';
                break;
            case 'cp2':
                t = cp2;
                pc = 'https://websiteoss.ecoflow.com/upload/image/1732330830496/NonstopPower-cp-dialog2.png';
                break;
            case 'cp3':
                t = cp3;
                pc = 'https://websiteoss.ecoflow.com/upload/image/1732330830312/NonstopPower-cp-dialog3.png';
                break;
        }
        const Icon = ({ url, title }: any) => (
            <div className="win3_item_title">
                <EfIcon className="win3_item_title_icon" pc={url} />
                <div className="win3_item_title_text">{title}</div>
            </div>
        );
        return {
            title: t('name'),
            desc: t('name_wh'),
            pc,
            specList: [
                {
                    title: <Icon url="https://websiteoss.ecoflow.com/upload/image/1732328760719/wifi.png" title={t('wifi')} />,
                    desc: t('wifi_time'),
                },
                {
                    title: <Icon url="https://websiteoss.ecoflow.com/upload/image/1732328760159/NAS.png" title={t('nas')} />,
                    desc: t('nas_time'),
                },
                {
                    title: <Icon url="https://websiteoss.ecoflow.com/upload/image/1732328760344/game.png" title={t('game')} />,
                    desc: t('game_time'),
                },
                {
                    title: <Icon url="https://websiteoss.ecoflow.com/upload/image/1732328760523/refrigerator.png" title={t('refrigerator')} />,
                    desc: t('refrigerator_time'),
                },
                {
                    title: <Icon url="https://websiteoss.ecoflow.com/upload/image/1732328759989/desktop.png" title={t('desktop')} />,
                    desc: t('desktop_time'),
                },
            ],
        };
    };

    const listAll = [getCpList('cp1'), getCpList('cp2'), getCpList('cp3')];

    return (
        <div className={styles.modal}>
            <EfProductCompareC items={listAll} theme="transparent" />
        </div>
    );
}
